export const SERVER_BASE_URL = 'http://localhost:5000';
export const SITE_URL = 'https://caption-search.netlify.com';
export const SITE_NAME = 'Caption Search';
export const SITE_DESC = 'A site to search a youtube video or playlist by its captions.';
export const SITE_IMG = '';
export const SITE_IMG_ALT = '';
export const LAMBDA_URL = 'https://u3f6zkvkt2.execute-api.us-east-1.amazonaws.com/prod';
